import { Badge, Flex, HStack, Text, Tooltip } from '@chakra-ui/react';

import { InfoCircleOutline, shadowStyles } from '@aslanpay/portal-common-lib';

import { Status } from 'app/constants/individual';

import { ProfileSectionProps } from './types';

function ProfileSection({
  children,
  title,
  status,
  tooltip = '',
  isEditMode = false,
  button = undefined,
  maxW = undefined,
  minW = undefined,
}: ProfileSectionProps) {
  const accountStatus = status ? Status[status] : null;

  return (
    <Flex
      maxW={maxW !== undefined ? maxW : '492px'}
      minW={minW}
      borderRadius="9px"
      border="1px solid"
      borderColor="brand.lightGray1"
      flexDir="column"
      flexGrow={1}
      boxShadow={isEditMode ? shadowStyles.dropdownMenu : ''}
    >
      <HStack
        minH="65px"
        px="20px"
        borderBottom="1px solid"
        borderColor="brand.lightGray1"
        alignItems="center"
        justify="space-between"
      >
        <Flex flex="1" minW={0} justify="space-between" gap="18px">
          <Text as="h5" textStyle="h5Bold" isTruncated>
            {title}
          </Text>
          {tooltip && (
            <Tooltip
              hasArrow
              shouldWrapChildren
              arrowPadding={0}
              placement="top-start"
              label={tooltip}
            >
              <InfoCircleOutline
                boxSize="18px"
                cursor="pointer"
                color="brand.darkGray"
                _hover={{ color: 'brand.purple' }}
              />
            </Tooltip>
          )}
        </Flex>
        {button}
        {accountStatus && (
          <Badge colorScheme={`badge.${accountStatus.color}`}>{accountStatus.value}</Badge>
        )}
      </HStack>
      <Flex flexDir="column" gap="20px" p="20px">
        {children}
      </Flex>
    </Flex>
  );
}

export default ProfileSection;
